import { Button, Chevron } from '@lmc/ui-kit'
import { Dropdown } from 'antd'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'

type ReviewLogDropdownButtonProps = {
  hasPermissionToCreateCase: boolean
  hasPermissionToCloseCase: boolean
  onCloseIncidentClick: () => void
  onCreateCaseClick: () => void
}

const ReviewLogDropdownButton = ({
  hasPermissionToCreateCase,
  hasPermissionToCloseCase,
  onCloseIncidentClick,
  onCreateCaseClick
}: ReviewLogDropdownButtonProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)
  const hasAnyPermission = hasPermissionToCloseCase || hasPermissionToCreateCase

  return (
    <Dropdown
      menu={{
        items: [
          {
            label: t(incidentReportsConstants.CLOSE_INCIDENT),
            key: '1',
            onClick: onCloseIncidentClick,
            disabled: !hasPermissionToCloseCase
          },
          ...(hasPermissionToCreateCase
            ? [
                {
                  label: t(incidentReportsConstants.CREATE_CASE),
                  key: '2',
                  onClick: onCreateCaseClick
                }
              ]
            : [])
        ]
      }}
      trigger={hasAnyPermission ? ['click'] : []}
      disabled={!hasAnyPermission}
    >
      {/* CM-3880: use disabledByPermission so the button clearly reads as
          disabled (greyed + "Permissions required" tooltip) for roles without
          case permissions (e.g. Audit View) — a plain `disabled` primary button
          didn't look disabled. */}
      <Button variant="primary" disabledByPermission={!hasAnyPermission}>
        Review
        <Chevron direction="down" />
      </Button>
    </Dropdown>
  )
}

export default ReviewLogDropdownButton
